module.exports = __webpack_public_path__ + "img/popup.95aa79cc.png";